import { useEffect, useState } from "react";
import Cookies from "js-cookie";
import { useFetchData } from "../../../helpers/api";
import { Link } from "react-router-dom";
import DashboardLayout from "../DashboardLayout";
import LoadingScreen from "../../../components/loading/LoadingScreen";
import { ordersDurationOptions } from "../data";
import { IoIosArrowBack, IoIosArrowForward } from "react-icons/io";

const customerId = Cookies.get("kalista-web-Id");

const MyOrders = () => {
  const savedDuration = sessionStorage.getItem("order_duration");
  const [orderDuration, setOrderDuration] = useState(savedDuration || "3");
  const [pazeSize, setPageSize] = useState("5");
  const [fromDate, setFromDate] = useState("");
  const [toDate, setToDate] = useState("");
  const [pageNo, setPageNo] = useState(1);

  useEffect(() => {
    const today = new Date();
    const pastDate = new Date();
    pastDate.setMonth(today.getMonth() - parseInt(orderDuration, 10));

    const formatDate = (date) => {
      return `${String(date.getDate()).padStart(2, "0")}/${String(
        date.getMonth() + 1
      ).padStart(2, "0")}/${date.getFullYear()}`;
    };

    setToDate(formatDate(today));
    setFromDate(formatDate(pastDate));
  }, [orderDuration]);

  const handleOrderDurationChange = (e) => {
    const value = e.target.value;
    setOrderDuration(value);
    sessionStorage.setItem("order_duration", value);
  };

  const { data: orderData, isLoading } = useFetchData(
    ["singleOrderData", fromDate, toDate, pazeSize, pageNo],
    "/Customer/getAllQuotation",
    {
      CustomerCode: customerId,
      FromDate: fromDate,
      ToDate: toDate,
      PageSize: pazeSize,
      PageNo: pageNo.toString(),
    },
    null,
    {
      enabled: !!customerId && !!fromDate && !!toDate,
      staleTime: 10 * 60 * 1000,
      keepPreviousData: true,
    }
  );

  const totalPages = Math.ceil(orderData?.totalProducts / pazeSize);
  const handlePageClick = (page) => {
    if (isLoading) return;
    if (page >= 1 && page <= totalPages) {
      setPageNo(page);
    }
  };
  const getPageNumbers = () => {
    if (totalPages <= 3) {
      return Array.from({ length: totalPages }, (_, i) => i + 1);
    }

    if (pageNo === 1) {
      return [1, 2, 3];
    }

    if (pageNo === totalPages) {
      return [totalPages - 2, totalPages - 1, totalPages];
    }

    return [pageNo - 1, pageNo, pageNo + 1];
  };

  return (
    <DashboardLayout pageClass="order_page">
      <div className="dashboard_content">
        <div className="dashboard_top_block">
          <div className="dashboard_top_left">
            <select
              name="order_page_size"
              id="order_page_size"
              value={pazeSize}
              onChange={(e) => setPageSize(e.target.value)}
              disabled={isLoading}
            >
              <option value="5">5</option>
              <option value="10">10</option>
              <option value="25">25</option>
            </select>
            <div className="order_pagination_con">
              <button
                disabled={pageNo === 1}
                onClick={() => handlePageClick(pageNo - 1)}
                className="pagination_arrows"
              >
                <IoIosArrowBack size="20px" />
              </button>

              {getPageNumbers().map((page) => (
                <button
                  key={page}
                  onClick={() => handlePageClick(page)}
                  className={
                    pageNo === page
                      ? "pagination_numbers active"
                      : "pagination_numbers"
                  }
                >
                  {page}
                </button>
              ))}

              <button
                disabled={pageNo === totalPages}
                onClick={() => handlePageClick(pageNo + 1)}
                className="pagination_arrows"
              >
                <IoIosArrowForward size="20px" />
              </button>
            </div>
          </div>
          <select
            name="order_page_duration"
            id="order_page_duration"
            value={orderDuration}
            onChange={handleOrderDurationChange}
            disabled={isLoading}
          >
            {ordersDurationOptions &&
              ordersDurationOptions.map((option) => (
                <option value={option.value} key={option.value}>
                  {option.label}
                </option>
              ))}
          </select>
        </div>
        {isLoading ? (
          <LoadingScreen />
        ) : (
          <div className="orders_block_con">
            {orderData?.quotationProducts.Data?.length ? (
              orderData.quotationProducts.Data.map((item) => (
                <div key={item.OrderId} className="order_block">
                  <img
                    src={process.env.REact_APP_IMG_URL + item.ImagePath}
                    alt={item.OrderNo}
                  />
                  <div className="left_info_con">
                    <Link to={`/order/${item.OrderId}`} className="order_title">
                      #{item.OrderNo}
                    </Link>
                    <div className="order_id">
                      ORDER ID: <span>{item.OrderId}</span>
                    </div>
                    <p className="order_po_no">
                      PO NO: <span>{item.PoNo}</span>
                    </p>
                    <p className="order_qty">
                      QTY: <span>{item.ItemQty}</span>
                    </p>
                    <p className="order_weight">
                      <span>
                        {item.GoldWt} GM | {item.ClientDiamondWt} CT
                      </span>
                    </p>
                  </div>
                  <div className="right_info_con">
                    <p className="order_status">
                      Labour Amount: <span>{item.Amount}</span>
                    </p>
                    <p className="order_salesperson">
                      Sales Person: <span>{item.SalesPersonName}</span>
                    </p>
                    <p className="order_secondStatus">
                      Billing Type: <span>{item.BillingType}</span>
                    </p>
                    {item.IsShowDate === true && (
                      <div className="order_date_con">
                        <p className="order_delivery">
                          Estimated Delivery : <span>15 Days</span>
                        </p>
                        <p className="order_date">
                          Order Date:{" "}
                          <span>
                            {new Intl.DateTimeFormat("en-US", {
                              month: "short",
                              day: "2-digit",
                              year: "numeric",
                            }).format(
                              new Date(parseInt(item.OrderDate.match(/\d+/)[0]))
                            )}
                          </span>
                        </p>
                      </div>
                    )}
                  </div>
                </div>
              ))
            ) : (
              <p>No orders found</p>
            )}
          </div>
        )}
      </div>
    </DashboardLayout>
  );
};

export default MyOrders;
